import { Typography } from '@mui/material';
import { useRef } from 'react';

import { BusinessPartnerPicker } from '@work4all/components/lib/components/entity-picker/business-partner-picker/BusinessPartnerPicker';
import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';

import { Customer } from '@work4all/models/lib/Classes/Customer.entity';
import { Supplier } from '@work4all/models/lib/Classes/Supplier.entity';

import { PickerTargetButton } from './PickerTargetButton';

type Props = {
  disabled?: boolean;
  value: Customer | Supplier;
  onChange: (value: Customer | Supplier | null) => void;
};

export function BusinessPartnerPickerCell({
  disabled,
  value,
  onChange,
}: Props) {
  const popoverRef = useRef<EntityPickerPopover>(null);

  return (
    <EntityPickerPopover
      ref={popoverRef}
      picker={
        <BusinessPartnerPicker
          value={value}
          onChange={onChange}
          multiple={false}
        />
      }
    >
      <PickerTargetButton disabled={disabled}>
        <Typography style={{ display: 'flex', alignItems: 'center' }}>
          {value?.name}
        </Typography>
      </PickerTargetButton>
    </EntityPickerPopover>
  );
}
